import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, coverUrl } from "../lib/api";
import { Badge } from "../components/ui/badge";

const STATUS_VARIANT = { paid: "default", pending: "secondary", refunded: "outline" };

export default function Orders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/orders").then((r) => setOrders(r.data)); }, []);

  return (
    <div className="container-page py-10" data-testid="orders-page">
      <h1 className="font-display text-4xl tracking-tight border-b border-border pb-3 mb-8">Order history</h1>
      {orders.length === 0 ? (
        <div className="text-center py-24 border border-dashed border-border rounded-sm">
          <div className="font-display text-3xl">No orders yet.</div>
          <div className="text-sm text-muted-foreground mt-2 italic">Your purchases will appear here.</div>
          <Link to="/browse" className="inline-block mt-6 bg-primary text-primary-foreground px-5 py-2.5 text-sm rounded-sm uppercase tracking-wide">Browse catalogue</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="border border-border rounded-sm p-5 bg-card" data-testid={`order-${o.id}`}>
              <div className="flex items-center justify-between mb-3">
                <div>
                  <div className="text-xs text-muted-foreground font-mono">Order #{o.id}</div>
                  <div className="text-sm mt-1">{o.created_at?.slice(0, 10)} · <Badge variant={STATUS_VARIANT[o.status] || "outline"} className="rounded-sm font-normal capitalize">{o.status}</Badge></div>
                </div>
                <div className="text-right">
                  <div className="text-xl font-semibold">{o.currency === "usd" ? "US$" : "A$"}{o.total.toFixed(2)}</div>
                </div>
              </div>
              <div className="divide-y divide-border border-t border-border">
                {o.items.map((it) => (
                  <div key={it.product_id} className="flex items-center gap-3 py-3">
                    <Link to={`/product/${it.product_id}`} className="w-10 h-12 bg-muted overflow-hidden rounded-sm border border-border/60">
                      <img src={coverUrl(it.product_id)} alt={it.title} className="object-cover w-full h-full" />
                    </Link>
                    <Link to={`/product/${it.product_id}`} className="flex-1 text-sm font-display hover:text-accent">{it.title}</Link>
                    <div className="text-sm">{o.currency === "usd" ? "US$" : "A$"}{it.price.toFixed(2)}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
